export default __webpack_public_path__ + "static/SSSpyView_screenshot-5@2x-77e119f721900a2da25fdfc1875a82bf.webp";